import { ALERT_DEFINITIONS } from "./alertDefinitions";

export function missingTokensAlert({
  onChainTokens = [],
  visibleTokens = [],
}) {
  const onChainCount = onChainTokens.length;
  const visibleCount = visibleTokens.length;

  if (onChainCount > visibleCount) {
    return {
      ...ALERT_DEFINITIONS.MISSING_TOKENS,
      detected: true,
      hiddenCount: onChainCount - visibleCount,
    };
  }

  return {
    ...ALERT_DEFINITIONS.MISSING_TOKENS,
    detected: false,
  };
}
